import { jsx as e } from "react/jsx-runtime";
const r = ({ size: l }) => l == 18 ? /* @__PURE__ */ e(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "presentation",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.6465 14.3536C13.8418 14.5488 14.1584 14.5488 14.3536 14.3536C14.5489 14.1583 14.5489 13.8417 14.3536 13.6464L8.70715 7.99997L14.3536 2.35357C14.5488 2.15831 14.5488 1.84172 14.3536 1.64646C14.1583 1.4512 13.8417 1.4512 13.6464 1.64646L8.00005 7.29286L2.35363 1.64645C2.15837 1.45118 1.84179 1.45118 1.64652 1.64645C1.45126 1.84171 1.45126 2.15829 1.64652 2.35355L7.29294 7.99997L1.64645 13.6465C1.45118 13.8417 1.45118 14.1583 1.64645 14.3536C1.84171 14.5488 2.15829 14.5488 2.35355 14.3536L8.00005 8.70708L13.6465 14.3536Z",
        fill: "var(--plac-primary-gray)"
      }
    )
  }
) : /* @__PURE__ */ e(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "presentation",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8873 3.65658C13.0375 3.50637 13.0375 3.26285 12.8873 3.11265C12.7371 2.96245 12.4936 2.96245 12.3434 3.11265L7.99998 7.45603L3.65664 3.11269C3.50644 2.96249 3.26291 2.96249 3.11271 3.11269C2.96251 3.26289 2.96251 3.50641 3.11271 3.65661L7.45606 7.99996L3.11265 12.3434C2.96245 12.4936 2.96245 12.7371 3.11265 12.8873C3.26285 13.0375 3.50638 13.0375 3.65658 12.8873L7.99998 8.54388L12.3434 12.8873C12.4936 13.0375 12.7372 13.0375 12.8874 12.8873C13.0376 12.7371 13.0376 12.4936 12.8874 12.3434L8.54391 7.99996L12.8873 3.65658Z",
        fill: "var(--plac-primary-gray)"
      }
    )
  }
);
export {
  r as UtilityCloseLightIcon
};
//# sourceMappingURL=index.es445.js.map
